import { Box, styled } from '@mui/material';

export const StyledCustomImageBlockContainer = styled(Box)<any>(
  ({ width }) => ({
    position: 'relative',
    maxWidth: width || 'auto',
  })
);
